export const environment = {
	production: false,
	msal: {
		clientId: '8904639e-e20b-4140-a31e-3ddba182dfc8',
		logoutUri: 'https://dev.steamleaks.xom.cloud',
		redirectUri: 'https://dev.steamleaks.xom.cloud/callback',
		authority: 'https://xomapps.b2clogin.com/tfp/xomapps.onmicrosoft.com/B2C_1A_signin',
		apiScopes: ['https://xomapps.onmicrosoft.com/28ed908e-ca6d-4ac0-bf63-a921b22ec40d/steamleaks-dev/Read'],
		b2cScopes: ['openid', 'https://xomapps.onmicrosoft.com/28ed908e-ca6d-4ac0-bf63-a921b22ec40d/steamleaks-dev/Read'],
		knownAuthorities: ['https://xomapps.b2clogin.com/xomapps.onmicrosoft.com/'],
		exxonSSODomainHint: 'ExxonMobilAADSSO',
		pingDomainHint: 'ExxonMobilPingFedSAML',
	},
	apiUrl: 'https://api-dev.steamleaks.xom.cloud/api/'
};
